import React from 'react';
import { useEffect } from 'react';
import CertificateCardGrid from '../Components/CertificatesCard';
import Footer from '../Components/Footer';
import Navbar2 from '../Components/NavCertificate';
// import Navbar from '../Components/NavCertificate';

const CertificatePage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);  // Scroll to the top of the page
      }, []);

    return (
        <div className='bg-[#242424] text-white font-inria' id='r'>
            <div>
              <Navbar2/>
            </div>
            <div className='md:flex md:justify-center'>
                <div className='mt-32 mb-10 md:m-20 md:mt-10'>
                    <div className="containe">
                        <svg class="svg-icon" height="100" preserveAspectRatio="xMidYMid meet" viewBox="0 0 100 100" width="100" x="0" xmlns="http://www.w3.org/2000/svg" y="0">
                            <path d="M62.11,53.93c22.582-3.125,22.304-23.471,18.152-29.929-4.166-6.444-10.36-2.153-10.36-2.153v-4.166H30.099v4.166s-6.194-4.291-10.36,2.153c-4.152,6.458-4.43,26.804,18.152,29.929l5.236,7.777v8.249s-.944,4.597-4.833,4.986c-3.903,.389-7.791,4.028-7.791,7.374h38.997c0-3.347-3.889-6.986-7.791-7.374-3.889-.389-4.833-4.986-4.833-4.986v-8.249l5.236-7.777Zm7.388-24.818s2.833-3.097,5.111-1.347c2.292,1.75,2.292,15.86-8.999,18.138l3.889-16.791Zm-44.108-1.347c2.278-1.75,5.111,1.347,5.111,1.347l3.889,16.791c-11.291-2.278-11.291-16.388-8.999-18.138Z">
                            </path>
                        </svg>
                        <div className="container__star">

                            <div className="star-eight"></div>
                        </div>

                        <div></div></div>
                </div>
                <div className='mt-10 md:mt-32'>
                    <h1 className='text-4xl text-center md:text-6xl'>Certificates</h1>
                </div>
            </div>
            <div className='mx-10 md:mx-20'>
                <CertificateCardGrid displayCount={Infinity} gridTemplate="grid-cols-1 md:grid-cols-3"/>
             </div>
             <div className='mt-10'>
                <Footer/>
             </div>
        </div>
    )
}

export default CertificatePage;
